import script from "./image.vue?vue&type=script&setup=true&lang=js"
export * from "./image.vue?vue&type=script&setup=true&lang=js"

import "./image.vue?vue&type=style&index=0&id=7c9c58df&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c9c58df"]])

export default __exports__